import { defineComponent } from "vue";

export default defineComponent({
  name: "MediaDeviceNotSupported",

  setup() {
    return {
    }
  },
})


